import { embed } from '@dintero/checkout-web-sdk';
import { CountryCodeType } from 'noddi-util';
import { useEffect, useRef, useState } from 'react';
import { NoddiCircularLoaderWithTrans } from '../Loading/NoddiCircularLoaderWithTrans';

const getLanguageForDintero = (countryCode: CountryCodeType) => {
  switch (countryCode) {
    case 'NO':
      return 'no';
    case 'SE':
      return 'sv';
    default:
      return 'en';
  }
};

export function DinteroSessionPaymentForm({
  sessionId,
  countryCode
}: {
  sessionId: string;
  countryCode: CountryCodeType;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    setIsLoading(true);
    /* eslint-disable promise/catch-or-return -- ESLint and oxlint each own one rule on this statement and only one next-line directive can sit above it; enabled again right below */
    // oxlint-disable-next-line typescript/no-floating-promises -- known gap: the embed().then chain has no rejection handler, so a failed Dintero embed leaves the form loading
    embed({
      container: ref.current,
      sid: sessionId,

      language: getLanguageForDintero(countryCode)
      // eslint-disable-next-line promise/always-return -- last link of the chain; nothing reads its value
    }).then(() => {
      setIsLoading(false);
      // Scroll to the embedded container once loading is complete
      setTimeout(() => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    });
    /* eslint-enable promise/catch-or-return */
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sessionId/countryCode omitted: embed once on mount; re-running would mount a second Dintero iframe
  }, []);

  return (
    <div ref={ref} className='mt-5 min-h-200'>
      {isLoading && <NoddiCircularLoaderWithTrans />}
    </div>
  );
}
